export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fff503ae5ab4a39b753c30ef5fba18948f0218c2e&name=fetchTypeahead!'